import React from 'react'
import { EasyZoomOnMove } from 'easy-magnify';

const Modal = ({
  open,
  onClose,
  project,
}: {
  open: any;
  onClose: () => void;
  project: any;
}) => {
  if (!open || !project) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-xl shadow-2xl w-[80vw] h-[80vh] max-w-[1200px] max-h-[900px] overflow-y-auto relative flex flex-col">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-900 text-2xl font-bold"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div className="p-6">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            {project.title}
          </h3>
          <p className="text-gray-700 mb-4">{project.modal?.description}</p>
          <div className="flex flex-wrap gap-2">
            {project.tech.map((tech: Array<String>, i: any) => (
              <span
                key={i}
                className="bg-[#00df9a]/10 text-[#00df9a] px-3 py-1 rounded-full text-xs font-semibold"
              >
                {tech}
              </span>
            ))}
          </div>

        </div>
        {project.modal?.iframeUrl ? (
          <div className="w-full aspect-video mb-4">
            <iframe
              src={project.modal.iframeUrl}
              title={project.title}
              className="w-full h-full rounded-lg border"
              allowFullScreen
            />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-4 mt-6 px-6 py-6">
            {project.modal?.images?.map((img: any, idx: any) => (
              <EasyZoomOnMove
                key={idx}
                mainImage={{
                  src: typeof img === "string" ? img : img.src,
                  alt: `${project.title} screenshot ${idx + 1}`,
                  width: 400,
                  height: 400,
                }}
                zoomImage={{
                  src: typeof img === "string" ? img : (img.zoomSrc || img.src),
                  alt: `${project.title} screenshot ${idx + 1} Zoom`,
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal